export interface User {
  id: number;
  fullName: string | null;
  firstName?: string | null;
  lastName?: string | null;
  avatarUrl?: string | null;
  email: string;
  phoneNumber?: string | null;
  jobTitle?: string | null;
}

export interface Reaction {
  emoji: string;
  userId: number;
}

export interface Comment {
  id: number;
  threadId: number;
  parentId: number | null;
  content: string;
  reactions: Reaction[];
  isPinned: boolean;
  hasAttachments: boolean;
  createdBy: number;
  createdAt: number;
  author: User;
}

export interface Thread {
  id: number;
  content: string;
  isPinned: boolean;
  createdAt: Date;
  author: User;
  reactions: Reaction[];
  comments: Comment[];
  firstCommentId?: number;
  url?: string;
  domain?: string;
  selector?: string;
  pinColor?: string;
}

export const AVAILABLE_REACTIONS = ['👍', '👎', '😄', '🎉', '😕', '❤️', '🚀', '👀', '✅', '🔄'];

export type { EditorAttachment } from './files';
